import {pxToRem} from '../../utills/pxToRem'

export const normalTextStyle = {
    fontSize: {base: pxToRem(12), lg: pxToRem(13)},
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}

export const orderDetailStyle = {
    flexDir: {base: 'column', lg: 'row'},
    mt: `${pxToRem(15)} !important`,
    gap: {base: pxToRem(10), lg: pxToRem(15)},
    hr: {
        mt: '0 !important',
        borderColor: 'cav_light_input_gray',
        bg: 'cav_light_input_gray',
        width: pxToRem(1),
        display: {base: 'none', lg: 'initial'}
    },
    span: {
        ...normalTextStyle,
        fontSize: {base: 'sm', lg: 'md'},
        textTransform: 'capitalize'
    }
}
